import React from "react";
import { withTranslation } from "react-i18next";
import { RegistryConfirmationData } from "./RegistryConfirmationData";
import QRCode from "qrcode.react";

import CardPaymentPromissoryNote from "./CardPaymentPromissoryNote";
import DetailOrderConfirmation from "./DetailOrderConfirmation";
import DisclaimerResponsabilitiesHTML from "../DisclaimerResponsabilities/DisclaimerResponsabilitiesHTML";
import PhotoEditorDefault from "../../PhotoEditorVirtual/PhotoEditorDefault";
import PaymentsView from "../PaymentViews/PaymentsView";

import { Typography, Button, CircularProgress } from "@material-ui/core";

class RegistryConfirmationIncompletePayment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tipo: this.props.tipo || 1,
            savingNewRegistry: false,
            paymentSuccess: false,
            paymentError: null,
            newRegistryResponse: null,
        };
    }

    buildJsonMail = () => {
        var jsonMail = {};
        jsonMail.inscritoKey = this.props.registryParticipantKeyConfirm;
        jsonMail.eventoIndex = "evento_" + this.props.eventDetail.iDEvento;

        jsonMail.detalleEvento = this.props.eventDetail;
        jsonMail.datos = this.props.registryParticipantDataConfirm;
        jsonMail.modalidades = this.props.eventSubEventsRegistry;
        jsonMail.inscripcionesConfiguracion = this.props.registryConfiguration;

        return jsonMail;
    };

    getDisplayData = (jsonMail) => {
        var color = "#000000";
        if (
            jsonMail.detalleEvento &&
            jsonMail.detalleEvento.organizador &&
            jsonMail.detalleEvento.organizador.colorOrganizador !== undefined
        ) {
            color = jsonMail.detalleEvento.organizador.colorOrganizador;
        }

        var numero = 0;
        if (jsonMail.datos && jsonMail.datos.numero !== undefined) {
            numero = jsonMail.datos.numero;
        }

        var distancia = "";
        var modIndex = "modalidad_" + jsonMail.datos.modalidad;
        if (
            jsonMail.datos &&
            jsonMail.datos.modalidad !== undefined &&
            jsonMail.modalidades &&
            jsonMail.modalidades[modIndex]
        ) {
            distancia = jsonMail.modalidades[modIndex].descripcionModalidad;
        }

        var rama = "";
        var ramaIndex = "";
        if (jsonMail.datos && jsonMail.datos.rama !== undefined) {
            ramaIndex = "rama_" + jsonMail.datos.rama;
            rama = jsonMail.datos.rama;
        }

        var categoriaJson = null;
        var categoria = "";
        var categoriaIndex = "";

        if (
            jsonMail.datos &&
            jsonMail.datos.categoria !== undefined &&
            jsonMail.modalidades &&
            jsonMail.modalidades[modIndex] &&
            jsonMail.modalidades[modIndex].ramaCat &&
            jsonMail.modalidades[modIndex].ramaCat[ramaIndex]
        ) {
            categoriaIndex = "categoria_" + jsonMail.datos.categoria;
            categoriaJson =
                jsonMail.modalidades[modIndex].ramaCat[ramaIndex].categorias[
                categoriaIndex
                ];

            if (categoriaJson) {
                categoria = categoriaJson.nombreCategoria;
            }
        }

        return {
            color,
            numero,
            distancia,
            rama,
            categoria,
            modIndex,
            ramaIndex,
            categoriaIndex,
            categoriaJson,
        };
    };

    handlePaymentSuccess = async (paymentResult) => {
        try {
            this.setState({
                savingNewRegistry: true,
                paymentError: null,
            });

            const jsonMail = this.buildJsonMail();

            const newRegistryData = {
                ...jsonMail.datos,
                incompletePaymentSourceRegistryKey: jsonMail.inscritoKey,
                statusPago: {
                    ...(jsonMail.datos.statusPago || {}),
                    ...(paymentResult || {}),
                    pagoCompleto: true,
                    fechaPagoCompleto: new Date().toISOString(),
                },
            };

            if (typeof this.props.onCreateNewRegistry === "function") {
                const response = await this.props.onCreateNewRegistry({
                    eventoIndex: jsonMail.eventoIndex,
                    eventDetail: jsonMail.detalleEvento,
                    registryConfiguration: jsonMail.inscripcionesConfiguracion,
                    eventSubEventsRegistry: jsonMail.modalidades,
                    originalRegistryKey: jsonMail.inscritoKey,
                    registryParticipantData: newRegistryData,
                    paymentResult,
                });

                this.setState({
                    savingNewRegistry: false,
                    paymentSuccess: true,
                    newRegistryResponse: response || null,
                });
            } else {
                console.warn(
                    "No se definió onCreateNewRegistry. Debes pasar esa prop para guardar el nuevo registro."
                );

                this.setState({
                    savingNewRegistry: false,
                    paymentSuccess: true,
                    newRegistryResponse: null,
                });
            }
        } catch (error) {
            console.error("Error al guardar nuevo registro después del pago:", error);

            this.setState({
                savingNewRegistry: false,
                paymentError:
                    (error && error.message) ||
                    this.props.t("confirmacion.errorGuardandoRegistro"),
            });
        }
    };

    handlePaymentError = (error) => {
        this.setState({
            paymentError:
                (error && error.message) || this.props.t("confirmacion.errorDurantePago"),
        });
    };

    renderPaymentSection = (jsonMail) => {
        const { savingNewRegistry, paymentSuccess, paymentError } = this.state;
        const { t } = this.props;

        return (
            <div className="row center-align">
                <div className="col s12">
                    <Typography
                        color="primary"
                        gutterBottom
                        variant={"h5"}
                        component="h2"
                    >
                        {t("confirmacion.completarPago")}
                    </Typography>
                </div>

                <div className="col s12">
                    <Typography
                        color="textSecondary"
                        gutterBottom
                        variant={"body1"}
                        component="p"
                    >
                        {t("confirmacion.registroCapturadoPagoIncompleto")}
                    </Typography>
                </div>

                {paymentSuccess && (
                    <div className="col s12">
                        <Typography
                            style={{ color: "green", fontWeight: 600 }}
                            gutterBottom
                            variant={"body1"}
                            component="p"
                        >
                            {t("confirmacion.pagoRealizadoCorrectamente")}
                        </Typography>
                    </div>
                )}

                {paymentError && (
                    <div className="col s12">
                        <Typography
                            style={{ color: "red", fontWeight: 600 }}
                            gutterBottom
                            variant={"body1"}
                            component="p"
                        >
                            {paymentError}
                        </Typography>
                    </div>
                )}

                {savingNewRegistry && (
                    <div className="col s12" style={{ marginBottom: 20 }}>
                        <CircularProgress />
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant={"body2"}
                            component="p"
                        >
                            {t("confirmacion.guardandoNuevoRegistro")}
                        </Typography>
                    </div>
                )}

                <div className="col s12">
                    <PaymentsView
                        currency={jsonMail.datos.monedaAUsar}
                        currencyBase={jsonMail.datos.monedaBase}
                        callback={null}
                        callbackCode={null}
                        order={jsonMail.datos.order}
                        currentOrder={jsonMail.datos}
                        eventDetail={jsonMail.detalleEvento}

                    />
                </div>
            </div>
        );
    };

    render() {
        const jsonMail = this.buildJsonMail();
        const { t } = this.props;

        if (
            !jsonMail ||
            !jsonMail.detalleEvento ||
            !jsonMail.datos ||
            !jsonMail.inscripcionesConfiguracion
        ) {
            return (
                <Typography color="primary" gutterBottom variant={"h5"} component="h2">
                    {t("confirmacion.cargandoConfirmacion")}
                </Typography>
            );
        }

        const idioma = "es";
        const jsonTextos = RegistryConfirmationData;
        const displayData = this.getDisplayData(jsonMail);


        var detallePagoTarjeta = null;
        if (
            jsonMail.datos &&
            jsonMail.datos.statusPago &&
            jsonMail.datos.statusPago.last4 !== undefined
        ) {
            detallePagoTarjeta = <CardPaymentPromissoryNote jsonMail={jsonMail} />;
        }

        var detalleOrden = (
            <DetailOrderConfirmation
                jsonMail={jsonMail}
                jsonTextos={jsonTextos}
                idioma={idioma}
                reference={this.props.oxxoReference}
                tipo={this.state.tipo}
            />
        );

        var nombresYApellidos =
            (jsonMail.datos.nombres || "") + " " + (jsonMail.datos.apellidos || "");

        return (
            <div>
                <div className="row center-align">
                    <Typography
                        color="secondary"
                        gutterBottom
                        variant={"subtitle2"}
                        component="h2"
                    >
                        {t("confirmacion.registroDetectadoPagoIncompleto")}
                    </Typography>

                    <Typography
                        color="primary"
                        gutterBottom
                        variant={"h4"}
                        component="h2"
                    >
                        {nombresYApellidos}
                    </Typography>

                    <Typography
                        color="secondary"
                        gutterBottom
                        variant={"subtitle2"}
                        component="h2"
                    >
                        {t("confirmacion.revisaDatosCompletaPago")}
                    </Typography>
                </div>

                <div className="row center-align">
                    <Typography
                        color="primary"
                        gutterBottom
                        variant={"h3"}
                        component="h2"
                    >
                        {jsonMail.detalleEvento.nombreEvento}
                    </Typography>
                </div>

                <div className="row center-align">
                    <div className="col s6 offset-s3">
                        <img
                            alt="logo Evento"
                            title="logo Evento"
                            src={jsonMail.detalleEvento.logoEvento}
                            style={{
                                border: "none",
                                borderRadius: "0px",
                                display: "block",
                                fontSize: "13px",
                                outline: "none",
                                textDecoration: "none",
                                width: "100%",
                            }}
                            width={212}
                        />
                    </div>
                </div>

                <hr />

                {jsonMail.inscripcionesConfiguracion.configuracion &&
                    jsonMail.inscripcionesConfiguracion.configuracion.dorsal &&
                    jsonMail.datos.numero > 0 && (
                        <div className="row center-align">
                            <div className="col s12">
                                <Typography
                                    color="primary"
                                    gutterBottom
                                    variant={"h4"}
                                    component="h2"
                                >
                                    {t("confirmacion.dorsalDigital")}
                                </Typography>
                            </div>

                            <div className="center-align col s12 m12">
                                <PhotoEditorDefault
                                    size="80%"
                                    participant={{
                                        raceNumber: jsonMail.datos.numero,
                                        athleteName: jsonMail.datos.nombres,
                                        athleteLastName: jsonMail.datos.apellidos,
                                    }}
                                    currentEvent={{
                                        distance: 10,
                                        raceNumberFontColor:
                                            jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                                                .raceNumberFontColor,
                                        raceNumberWhiteBack:
                                            jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                                                .raceNumberWhiteBack,
                                        raceNumberVertical: jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                                            .raceNumberVertical || 1

                                    }}
                                    urlPhoto={
                                        jsonMail.inscripcionesConfiguracion.configuracion.dorsal
                                            .raceNumberImage
                                    }
                                    type={"raceNumber"}
                                />
                            </div>
                        </div>
                    )}

                <hr />

                <div className="row center-align">
                    <div className="col s12">
                        <Typography
                            color="primary"
                            gutterBottom
                            variant={"h5"}
                            component="h2"
                        >
                            {jsonTextos[idioma].tituloDatos}
                        </Typography>
                    </div>


                    <div className="col s4 center-align">
                        <Typography
                            color="primary"
                            gutterBottom
                            variant={"subtitle1"}
                            component="h2"
                        >
                            {jsonTextos[idioma].Distancia}
                            <br />
                            <b className="center-align">{displayData.distancia}</b>
                        </Typography>
                    </div>

                    <div className="col s4 center-align">
                        <Typography
                            color="primary"
                            gutterBottom
                            variant={"subtitle1"}
                            component="h2"
                        >
                            {jsonTextos[idioma].Rama}
                            <br />
                            <b className="center-align">{displayData.rama}</b>
                        </Typography>
                    </div>

                    <div className="col s4 center-align">
                        <Typography
                            color="primary"
                            gutterBottom
                            variant={"subtitle1"}
                            component="h2"
                        >
                            {jsonTextos[idioma].Categoria}
                            <br />
                            <b>{displayData.categoria}</b>
                        </Typography>
                    </div>
                </div>

                <hr />

                {detalleOrden}

                {detallePagoTarjeta && (
                    <>
                        <hr />
                        {detallePagoTarjeta}
                    </>
                )}

                <hr />


                <hr />

                {this.renderPaymentSection(jsonMail)}

                <footer />
            </div>
        );
    }
}

export default withTranslation("inscripcion")(RegistryConfirmationIncompletePayment);